import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "App";

// ─── Patch ResizeObserver to prevent "loop" warnings in CRA dev overlay ───
// This is a known benign issue with Radix UI + Framer Motion combinations.
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) return;
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
